import React from "react";
import {makeStyles} from "@material-ui/core";
import {toAbsoluteUrl} from '../../_helpers';

export function SplashScreen() {
    return (
        <div className="splash-screen">
            <img src={toAbsoluteUrl("/media/logos/OptimumDesk-logo.png")} alt="OptimumDesk logo"/>
        </div>
    );
}
